export enum EDashboardTopsModelTypes {
  NGR = 'top_for_ngr',
  TRACKERS = 'top_trackers',
  PLAYERS = 'top_players',
}
